<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
      <v-row dense>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-select
            :items="caseStatusArray"
            label="案件進度"
            dense
            class="font-weight-normal"
            v-model="queryObject.status"
            @change="getDataFromApi"
            clearable
          ></v-select>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6">
          <v-text-field
            v-model="queryObject.deptName"
            @input="getDataFromApi();"
            clearable
            @click:clear="getDataFromApi();"
            label="需求單位名稱"
            type="text"
            dense
            class="font-weight-normal"
          ></v-text-field>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6">
          <v-select
            :items="getCodeDateUtil('lang')"
            label="語言別"
            dense
            class="font-weight-normal"
            v-model="queryObject.language"
            @change="getDataFromApi"
            clearable
          ></v-select>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="6">
          <v-select
            :items="getCodeDateUtil('serveType')"
            label="服務類型"
            dense
            class="font-weight-normal"
            v-model="queryObject.caseType"
            @change="getDataFromApi"
            clearable
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-toolbar-title>
          <v-row class="pa-3 ma-5" align="center" justify="center">
            <span class="red--text">共 {{totalCount}} 筆，每頁筆數</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark text color="red" class="ml-2" v-on="on">
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(number, index) in itemsPerPageArray"
                  :key="index"
                  @click="updateItemsPerPage(number)"
                >
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-toolbar-title>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="tableData"
            :options.sync="options"
            :server-items-length="totalCount"
            :loading="loading"
            class="elevation-1"
            widths="1500"
            :footer-props="{
               itemsPerPageText:'每頁筆數'
            }"
            no-data-text="無資料"
            loading-text="資料傳輸中"
            multi-sort
            :page.sync="currentPage"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.detailStatus="{ item }">
              <v-icon
                v-if="item.detailStatus == 'I10' || (item.commentToDept!=null &&item.commentToDept!='')"
              >mdi-check</v-icon>
            </template>
            <template v-slot:item.isCommentToInterpreter="{ item }" style="align='center'">
              <v-icon v-if="item.isCommentToInterpreter == 'Y'">mdi-check</v-icon>
              <!-- <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon> -->
            </template>

            <template v-slot:item.status="{ item }">
              <v-chip
                v-if="userProfile.memberAccount.type=='CCC' && item.detailStatus=='I06'"
                :color="getColor(item.detailStatus)"
                dark
                @click="dialogResponeIp = !dialogResponeIp;targetItem = item; setDialogRadio(item)"
              >{{ convertIpStatusToWord(item.detailStatus) }}</v-chip>
              <v-chip
                v-else-if="userProfile.memberAccount.type=='CCC'"
                :color="getColor(item.status)"
                dark
                @click="dialogResponeIp = !dialogResponeIp;targetItem = item; setDialogRadio(item)"
              >{{ convertStatusToWord(item.status) }}</v-chip>
              <v-chip
                v-else-if="item.detailStatus == 'I09' || item.detailStatus == 'I10'"
                :color="getColor(item.status)"
                dark
                @click="dialogResponeDept= !dialogResponeDept;targetItem = item; setDialogRadio(item)"
              >{{ convertStatusToWord(item.status) }}</v-chip>
              <v-chip
                v-else
                :color="getColor(item.status)"
                dark
                @click="deptResponseObject(item.caseId)"
              >{{ convertStatusToWord(item.status) }}</v-chip>
              <!-- <v-chip
                :color="getColor(item.status)"
                dark
                @click="dialogResponeDept = !dialogResponeDept;targetItem = item;"
              >{{ item.status }}2</v-chip>-->
            </template>
            <template v-slot:item.serviceDate="{ item }">
              {{ getDateFormat(item.serviceDate, "yyyy-MM-dd", true)}}
              <v-chip
                v-if="userProfile.memberAccount.type == 'AAA' && 
                (item.status =='C05' ||  item.status =='C06' || item.status =='C09') && checkServiceDate(item)
                "
                small
                dark
                @click="copyCase(item.caseId)"
              >案件複製</v-chip>
            </template>
          </v-data-table>
          <div class="text-center pa-2 ma-2">
            <v-pagination
              color="red"
              v-model="currentPage"
              :length="maxPage"
              :total-visible="9"
              @input="getDataFromApi()"
            ></v-pagination>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialogResponeDept" max-width="1024" v-if="dialogResponeDept">
      <v-card style="font-family:Microsoft JhengHei;">
        <v-card-title class="red" dark>
          <h2>
            <font style="color:white">詳細資訊</font>
          </h2>
        </v-card-title>
        <v-container>
          <v-row dense>
            <v-col cols="12" md="12">
              <h4>{{targetItem.deptName}}</h4>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              案件編號：{{targetItem.caseNo}}
              <br />
              語言別：{{targetItem.language}}
              <br />
              需求時間：{{convertDBDateToString(targetItem.serviceDate)}}
              <br />
              開始時間：{{targetItem.estimatedServiceStartTime}}
              <br />
              預計時數：{{targetItem.estimatedHours}}小時
              <br />
              服務地點：{{targetItem.serviceDistrict}}{{targetItem.serviceAddress}}
              <br />
            </v-col>
            <v-col cols="12" md="6">
              案件類型：{{targetItem.caseType}}
              <br />
              案件敘述：{{targetItem.caseNote}}
              <br />
              計費方式：{{targetItem.feeType}}
              <br />
              回覆期限：{{getDateFormat(targetItem.responseDueDate,"yyyy-MM-dd HH:mm",true)}}
              <br />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              cols="12"
              md="12"
              v-if="targetItem.status!='C01' && targetItem.status!='C09' && targetItem.detailStatus!='I06'"
            >
              聯絡人：{{targetItem.contactName}}
              <br />
              聯絡電話：{{targetItem.contactHomeTel}}
              <br />
              行動電話：{{targetItem.contactMobileTel}}
              <br />
            </v-col>
          </v-row>
          <v-row dense style="height: 20px;">
            <v-col cols="12" md="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row
            dense
            v-if="targetItem.status=='C04' && (targetItem.detailStatus=='I09' || targetItem.detailStatus=='I10')"
          >
            <v-col cols="12" md="12">
              <h4>服務紀錄</h4>
            </v-col>
          </v-row>
          <v-row
            dense
            v-if="targetItem.status=='C04' && (targetItem.detailStatus=='I09' || targetItem.detailStatus=='I10')"
          >
            <v-col cols="12" md="12">
              通譯報到時間：{{getDateFormat(targetItem.checkInDatetime,"yyyy-MM-dd HH:mm:ss",true)}}
              <br />
              服務開始時間：{{getDateFormat(targetItem.startServiceDatetime,"yyyy-MM-dd HH:mm:ss",true)}}
              <br />
              服務結束時間：{{getDateFormat(targetItem.finishServiceDatetime,"yyyy-MM-dd HH:mm:ss",true)}}
              <br />
              服務時數：{{getTimeInterval(targetItem.finishServiceDatetime-targetItem.startServiceDatetime)}}
              <br />
            </v-col>
          </v-row>
          <v-row
            dense
            v-if="targetItem.status=='C04' && (targetItem.detailStatus=='I09' || targetItem.detailStatus=='I10')"
          >
            <v-col cols="12" md="12" align="center" justify="center">
              <v-btn
                v-if="userProfile.memberAccount.type == 'AAA' && targetItem.isCommentToInterpreter!='Y'"
                color="red"
                class="ma-2"
                @click.prevent="dialogRating=true"
              >
                <font style="color:white;font-size:18px">給通譯人員評價</font>
              </v-btn>
              <v-btn
                v-if="userProfile.memberAccount.type == 'AAA' && targetItem.isCommentToInterpreter == 'Y'"
                color="red"
                class="ma-2"
                @click.prevent="getDetailScoreComment(targetItem);dialogRatingContent=true"
              >
                <font style="color:white;font-size:18px">查看對通譯人員評價</font>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRating" width="500px" v-if="dialogRating">
      <v-card style="font-family:Microsoft JhengHei;">
        <v-card-title class="red" dark>
          <h2>
            <font style="color:white">給通譯人員評價</font>
          </h2>
        </v-card-title>
        <v-container>
          <v-row dense>
            <v-col cols="12" md="12">
              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    整體評價：
                    <v-rating
                      aria-label
                      v-model="scoreAll"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      hover
                    ></v-rating>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    專業素養：
                    <v-rating
                      v-model="scoreProfession"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      hover
                    ></v-rating>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    服務態度：
                    <v-rating
                      v-model="scoreAttitude"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      hover
                    ></v-rating>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    評價內容：
                    <v-textarea v-model="commentIp" class="font-weight-normal" clearable outlined />
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red"
                  style="color:white;"
                  class="ma-2"
                  @click.prevent="commentInterpreter()"
                >確認</v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRatingContent" width="500px" v-if="dialogRatingContent">
      <v-card style="font-family:Microsoft JhengHei;">
        <v-card-title class="red" dark>
          <h2>
            <font style="color:white">通譯人員評價</font>
          </h2>
        </v-card-title>
        <v-container>
          <v-row dense>
            <v-col cols="12" md="12">
              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    整體評價：
                    <v-rating
                      readonly
                      aria-label
                      v-model="targetItem.scoreAll"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      hover
                    ></v-rating>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    專業素養：
                    <v-rating
                      readonly
                      v-model="targetItem.scoreProfession"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      hover
                    ></v-rating>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    服務態度：
                    <v-rating
                      readonly
                      v-model="targetItem.scoreAttitude"
                      color="yellow darken-3"
                      background-color="grey darken-1"
                      empty-icon="$ratingFull"
                      hover
                    ></v-rating>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    評價內容：
                    <v-textarea
                      readonly
                      v-model="targetItem.commentIp"
                      class="font-weight-normal"
                      outlined
                    />
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogResponeIp" max-width="1024" v-if="dialogResponeIp">
      <v-card style="font-family:Microsoft JhengHei;">
        <v-card-title class="red" dark>
          <h2>
            <font style="color:white">詳細資訊</font>
          </h2>
        </v-card-title>
        <v-container>
          <v-row dense>
            <v-col cols="12" md="12">
              <h4>{{targetItem.deptName}}</h4>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              案件編號：{{targetItem.caseNo}}
              <br />
              語言別：{{targetItem.language}}
              <br />
              需求時間：{{convertDBDateToString(targetItem.serviceDate)}}
              <br />
              開始時間：{{targetItem.estimatedServiceStartTime}}
              <br />
              預計時數：{{targetItem.estimatedHours}}小時
              <br />
              服務地點：{{targetItem.serviceDistrict}}{{targetItem.serviceAddress}}
              <br />
            </v-col>
            <v-col cols="12" md="6">
              案件類型：{{targetItem.caseType}}
              <br />
              案件敘述：{{targetItem.caseNote}}
              <br />
              計費方式：{{targetItem.feeType}}
              <br />
              回覆期限：{{getDateFormat(targetItem.responseDueDate,"yyyy-MM-dd HH:mm",true)}}
              <br />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              cols="12"
              md="12"
              v-if="targetItem.status!='C01' && targetItem.status!='C09' && targetItem.detailStatus!='I06'"
            >
              聯絡人：{{targetItem.contactName}}
              <br />
              聯絡電話：{{targetItem.contactHomeTel}}
              <br />
              行動電話：{{targetItem.contactMobileTel}}
              <br />
            </v-col>
          </v-row>
          <v-row dense style="height: 20px;">
            <v-col cols="12" md="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col
              cols="12"
              v-if="targetItem.status=='C01' && targetItem.detailStatus!='I06' && checkResponseDueDate(targetItem)"
            >
              <h4>服務意願</h4>
              <v-radio-group v-model="dialogRadio" class="font-weight-normal" dense>
                <v-radio
                  label="可服務"
                  value="I01"
                  color="red"
                  @change="dialogRadio='I01';checkObject()"
                ></v-radio>
                <v-radio
                  label="無法服務"
                  value="I02"
                  color="red"
                  @change="dialogRadio='I02';checkObject()"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" v-if="targetItem.status=='C02' && targetItem.detailStatus!='I06'">
              <h4>服務意願</h4>
              <v-radio-group v-model="dialogRadio" class="font-weight-normal" dense>
                <v-radio
                  label="確認可服務"
                  value="I04"
                  color="red"
                  @change="dialogRadio='I04';checkObject()"
                ></v-radio>
                <v-radio
                  label="取消案件"
                  value="I05"
                  color="red"
                  @change="dialogRadio='I05';checkObject()"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" v-else-if="targetItem.status=='C03' && targetItem.detailStatus=='I04'">
              <h4>服務紀錄</h4>
              <v-radio-group v-model="dialogRadio" class="font-weight-normal" dense>
                <v-radio
                  label="現場報到"
                  value="I07"
                  color="red"
                  @change="dialogRadio='I07';getCheckInDatetimeAndPosition()"
                ></v-radio>
                <v-radio
                  label="取消案件"
                  value="I05"
                  color="red"
                  @change="dialogRadio='I05';checkObject()"
                ></v-radio>
              </v-radio-group>
              <span v-if="dialogRadio=='I07'">
                <div align="center">
                  <v-btn color="red" class="ma-1" large @click.prevent="checkObject">
                    <font style="color:white;font-size:18px">我要報到</font>
                  </v-btn>
                </div>
                <br />
                報到時間：{{showCheckInDatetime}}
                <br />
                目前位置：{{targetAddress}}
                <br />
                <!-- <v-btn
                  v-if="targetAddress!=''"
                  color="red"
                  class="ma-1"
                  large
                  @click.prevent="checkObject"
                >-->
              </span>
              <!-- <v-radio-group v-model="dialogRadio" class="font-weight-normal" dense>
              </v-radio-group>-->
              <gmap-map
                v-if="dialogRadio=='I07'"
                :center="targetPosition"
                :zoom="16"
                style="width: 330px; height: 400px"
                @rightclick="mapRclicked"
              >
                <gmap-marker
                  v-if="dialogRadio=='I07'"
                  :position="targetPosition"
                  :clickable="true"
                  @click="center=targetPosition"
                ></gmap-marker>
              </gmap-map>
            </v-col>

            <v-col cols="12" v-if="targetItem.status=='C07' && targetItem.detailStatus=='I07'">
              <h4>服務紀錄</h4>
              <span v-if="dialogRadio=='I07' || dialogRadio=='I08'">
                通譯報到時間：{{getDateFormat( targetItem.checkInDatetime, "yyyy-MM-dd HH:mm:ss",true )}}
                <br />
              </span>
              <div align="center">
                <v-btn
                  color="red"
                  class="ma-1"
                  large
                  @click.prevent="dialogRadio='I08';checkObject()"
                >
                  <font style="color:white;font-size:18px">開始服務</font>
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" v-if="targetItem.status=='C08' && targetItem.detailStatus=='I08'">
              <h4>服務紀錄</h4>
              <span v-if="dialogRadio=='I08' || dialogRadio=='I09'">
                通譯報到時間：{{getDateFormat( targetItem.checkInDatetime, "yyyy-MM-dd HH:mm:ss",true )}}
                <br />
                服務開始時間：{{getDateFormat( targetItem.startServiceDatetime, "yyyy-MM-dd HH:mm:ss",true )}}
                <br />
              </span>
              <div align="center">
                <v-btn
                  color="red"
                  class="ma-1"
                  large
                  @click.prevent="dialogRadio='I09';checkObject()"
                >
                  <font style="color:white;font-size:18px">結束服務</font>
                </v-btn>
              </div>
            </v-col>

            <v-col
              cols="12"
              v-if="targetItem.status=='C04' && (targetItem.detailStatus=='I09' || targetItem.detailStatus=='I10')"
            >
              <h4>服務紀錄</h4>
              通譯報到時間：{{getDateFormat( targetItem.checkInDatetime, "yyyy-MM-dd HH:mm:ss",true )}}
              <br />
              服務開始時間：{{getDateFormat( targetItem.startServiceDatetime, "yyyy-MM-dd HH:mm:ss",true )}}
              <br />
              服務結束時間：{{getDateFormat( targetItem.finishServiceDatetime, "yyyy-MM-dd HH:mm:ss",true )}}
              <br />
              服務時數：{{ getTimeInterval(targetItem.finishServiceDatetime-targetItem.startServiceDatetime) }}
              <br />
              <div align="center">
                <v-btn
                  v-show="targetItem.detailStatus=='I09'"
                  color="red"
                  class="ma-1"
                  large
                  @click.prevent="dialogRadio='I10';checkObject()"
                >
                  <font style="color:white;font-size:18px">給需求單位意見回饋</font>
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" v-if="targetItem.status=='C05' && targetItem.detailStatus!='I06'">
              <h4>案件取消</h4>
              案件取消時間：{{getDateFormat(targetItem.cancelDate,"yyyy-MM-dd HH:mm:ss",true )}}
              <br />
              案件取消原因：{{targetItem.cancelCaseReason}}
            </v-col>
            <v-col cols="12" v-if="targetItem.status=='C06' && targetItem.detailStatus!='I06'">
              <h4>通譯取消案件</h4>
              通譯取消案件時間：{{getDateFormat(detailItem.cancelDate,"yyyy-MM-dd HH:mm:ss",true)}}
              <br />
              通譯取消案件原因：{{detailItem.cancelReason}}
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <!-- <v-card style="font-family:Microsoft JhengHei;">
        <v-card-title class="red" dark>
          <h2>
            <font style="color:white">詳細資訊</font>
          </h2>
        </v-card-title>
        <v-container>
          <v-row dense>
            <v-col cols="2">
              <v-card-title>
                <h1>服務意願</h1>
              </v-card-title>
            </v-col>
            <v-col cols="10" v-if="targetItem.status=='媒合中'">
              <v-radio-group v-model="dialogRadio" row class="font-weight-normal" dense>
                <v-radio label="可服務" value="Y" color="red" @change="checkObject"></v-radio>
                <v-radio label="無法服務" value="N" color="red" @change="checkObject"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="10" v-else>
              <v-radio-group v-model="dialogRadio" row class="font-weight-normal" dense>
                <v-radio label="可服務" v-if="dialogRadio =='Y'" value="Y" color="red" readonly></v-radio>
                <v-radio label="無法服務" v-if="dialogRadio =='N'" value="N" color="red" readonly></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <v-card-title>
                <h1>{{targetItem.deptName}}</h1>
              </v-card-title>
            </v-col>
            <v-col cols="6">
              <v-text-field value="法語" readonly label="語言別" dense filled class="font-weight-normal" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                value="2019-11-11"
                readonly
                label="需求時間"
                dense
                filled
                class="font-weight-normal md6"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                value="10:00"
                readonly
                label="開始時間"
                dense
                filled
                class="font-weight-normal"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                value="2小時"
                readonly
                label="預計時數"
                dense
                filled
                class="font-weight-normal"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                value="臺北市-中正區"
                readonly
                label="服務地點"
                dense
                filled
                class="font-weight-normal"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                value="法院陪同出席"
                readonly
                label="案件類型"
                dense
                filled
                class="font-weight-normal"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                value="勞動部計費方式"
                readonly
                label="計費方式"
                dense
                filled
                class="font-weight-normal"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                value="2019-11-10 10:00"
                readonly
                label="回覆期限"
                dense
                filled
                class="font-weight-normal"
              />
            </v-col>
            <v-col cols="12" md="12">
              <v-textarea
                v-model="targetItem.deptName"
                readonly
                label="案件敘述"
                dense
                filled
                class="font-weight-normal"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>-->
    </v-dialog>
  </v-form>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
import { mapGetters, mapActions } from "vuex";

import { API_KEY } from "./API_KEY";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: API_KEY,
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
});
let msgServer;

export default {
  components: {
    // InterpreterDetail
  },
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    }),
    filteredKeys() {
      return this.keys.filter(key => key !== `Name`);
    }
  },
  data() {
    return {
      // date: null,
      nowDateString: this.getDateFormat(new Date(), "yyyy-MM-dd", false),
      caseStatusArray: [],
      detailItem: null,
      menu: false,
      dialogResponeIp: false,
      dialogResponeDept: false,
      dialogRating: false,
      dialogRadio: null,
      valid: false,
      firstname: "",
      lastname: "",
      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      rating: 3.5,
      targetItem: {},
      selectedArray: [],
      selectOption: ["A", "B"],
      totalCount: 0,
      loading: true,
      options: {},
      headers: [
        { text: "案件編號", value: "caseNo", width: 100 },
        { text: "需求單位", value: "deptName", width: 100 },
        { text: "需求時間", value: "serviceDate", width: 110 },
        { text: "語言別", value: "language", width: 100 },
        { text: "案件類型", value: "caseType", width: 100 },
        { text: "通譯人員", value: "interpreter", width: 100 },
        { text: "案件進度", value: "status", width: 100 },
        {
          // text: "通譯填寫意見回饋",
          text: "通譯回饋",
          value: "detailStatus",
          width: 50,
          align: "center"
        },
        {
          // text: "需求單位填寫評價",
          text: "單位評價",
          value: "isCommentToInterpreter",
          width: 50,
          divider: true,
          align: "center"
        }
      ],

      tableData: [],
      queryObject: {},
      itemsPerPage: 5,
      currentPage: 1,
      maxPage: 0,
      pageCount: 0,
      itemsPerPageArray: [5, 10, 30, 50],
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr")),
      targetPosition: { lat: null, lng: null },
      checkInDatetime: "",
      showCheckInDatetime: "",
      targetAddress: "",
      cancelReason: "",
      confirmDateTime: "",
      startServiceDatetime: "",
      finishServiceDatetime: "",
      comment: "",
      scoreAll: 0,
      scoreProfession: 0,
      scoreAttitude: 0,
      commentIp: "",
      dialogRatingContent: false
    };
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    mapRclicked(mouseArgs) {
      this.targetPosition.lat = mouseArgs.latLng.lat();
      this.targetPosition.lng = mouseArgs.latLng.lng();
    },
    roundDecimal(val, precision) {
      return (
        Math.round(Math.round(val * Math.pow(10, (precision || 0) + 1)) / 10) /
        Math.pow(10, precision || 0)
      );
    },
    checkResponseDueDate(item) {
      var now = new Date();
      if (item.responseDueDate >= now.getTime()) return true;
      else return false;
    },
    checkServiceDate(item) {
      let vm = this;
      if (
        vm.getDateFormat(item.serviceDate, "yyyy-MM-dd", true) >=
        vm.nowDateString
      )
        return true;
      else return false;
    },
    getCheckInDatetimeAndPosition() {
      let vm = this;
      vm.checkInDatetime = new Date();
      vm.showCheckInDatetime = vm.getDateFormat(
        vm.checkInDatetime,
        "yyyy-MM-dd HH:mm:ss"
      );

      this.$getLocation({
        enableHighAccuracy: true, //defaults to false
        timeout: Infinity, //defaults to Infinity
        maximumAge: 0 //defaults to 0
      }).then(coordinates => {
        console.log(coordinates);
        vm.targetPosition.lat = coordinates.lat;
        vm.targetPosition.lng = coordinates.lng;
        vm.getAddress(coordinates.lat, coordinates.lng);
      });
    },
    getAddress(lat, lng) {
      let vm = this;
      let mapUrl =
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        lat +
        "," +
        lng +
        "&key=" +
        API_KEY;
      vm.axios.get(mapUrl, {}).then(function(response) {
        vm.targetAddress = response.data.results[0].formatted_address;
      });
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;

      this.getDataFromApi();
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        console.log("reject " + reject);

        const { sortBy, sortDesc } = this.options;

        let sortColumnNameList = [];

        sortBy.forEach((element, index) => {
          sortColumnNameList[index] = (sortDesc[index] ? "-" : "") + element;
        });
        if (sortColumnNameList.length == 0)
          sortColumnNameList = ["-createDate"];
        let vm = this;

        var criterionStr = JSON.stringify({});

        if (
          vm.userProfile.memberAccount.type == "AAA" &&
          !vm.userProfile.sysAdmin
        ) {
          vm.queryObject.deptId = vm.userProfile.memberAccount.mainDeptId;
        }
        var queryObjectStr = JSON.stringify(vm.queryObject);

        var queryPagerStr = JSON.stringify({
          pageSize: vm.itemsPerPage,
          currentPage: vm.currentPage,
          sortColumnNameList: sortColumnNameList
        });

        console.log("query " + queryObjectStr);

        let apiUrl = "interpreterCase";
        if (vm.userProfile.memberAccount.type == "CCC") {
          apiUrl = "interpreterCaseByMemberId";
          vm.headers = [
            { text: "案件編號", value: "caseNo", width: 100 },
            { text: "需求單位", value: "deptName", width: 100 },
            { text: "需求時間", value: "serviceDate", width: 110 },
            { text: "語言別", value: "language", width: 100 },
            { text: "案件類型", value: "caseType", width: 100 },
            { text: "案件進度", value: "status", width: 100 },
            {
              text: "通譯填寫意見回饋",
              value: "detailStatus",
              width: 150,
              align: "center"
            }
          ];
        } else if (vm.userProfile.memberAccount.type == "BBB") {
          apiUrl = "interpreterCaseByMemberDeptIdForTraining";
          criterionStr = JSON.stringify({
            in: [
              { propertyName: "status", value: "C03" },
              { propertyName: "status", value: "C04" },
              { propertyName: "status", value: "C06" },
              { propertyName: "status", value: "C07" },
              { propertyName: "status", value: "C08" }
            ]
          });

          vm.headers = [
            { text: "案件編號", value: "caseNo", width: 100 },
            { text: "需求單位", value: "deptName", width: 100 },
            { text: "需求時間", value: "serviceDate", width: 110 },
            { text: "語言別", value: "language", width: 100 },
            { text: "案件類型", value: "caseType", width: 100 },
            { text: "通譯人員", value: "interpreter", width: 100 },
            { text: "案件進度", value: "status", width: 100 },
            {
              // text: "通譯填寫意見回饋",
              text: "通譯回饋",
              value: "detailStatus",
              width: 50,
              align: "center"
            }
          ];
        }

        vm.axios
          .get(
            vm.idbServerUrl +
              "idb/" +
              apiUrl +
              "?queryString=" +
              encodeURIComponent(queryObjectStr) +
              "&queryPager=" +
              encodeURIComponent(queryPagerStr) +
              "&criterion=" +
              encodeURIComponent(criterionStr),
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: vm.$localStorage.get("idb_login_token")
              }
            }
          )
          .then(function(response) {
            var dataResponse = JSON.stringify(response.data);
            console.log(dataResponse);
            vm.tableData = response.data.resultList;
            vm.loading = false;
            // vm.desserts = response.data.resultList;
            vm.totalCount = response.data.totalCount;
            vm.currentPage = response.data.currentPage;
            vm.maxPage = response.data.maxPage;
            if (vm.userProfile.memberAccount.type == "CCC") {
              vm.tableData.forEach(item => {
                item.detailStatus = item.interpreterCaseDetails.find(
                  element => {
                    return (
                      element.memberId == vm.userProfile.memberAccount.uuid
                    );
                  }
                ).status;
              });
            } else {
              vm.tableData.forEach(item => {
                let colseCase = item.interpreterCaseDetails.find(element => {
                  return element.status == "I09" || element.status == "I10";
                });
                if (colseCase != null) item.detailStatus = colseCase.status;

                let interpreter = item.interpreterCaseDetails.find(element => {
                  return (
                    element.status == "I04" ||
                    element.status == "I07" ||
                    element.status == "I08" ||
                    element.status == "I09" ||
                    element.status == "I10"
                  );
                });
                if (interpreter != null)
                  item.interpreter = interpreter.memberName;
              });
            }
            // let items = vm.tableData;
            // const total = items.length;
            // resolve({
            //   items,
            //   total
            // });
          })
          .catch(function(error) {
            vm.handErrorUtil(error);
            console.log(error);
          });
      });
    },
    setDialogRadio(item) {
      let vm = this;
      console.log(JSON.stringify(item));
      let detail = item.interpreterCaseDetails.find(element => {
        // if (element.memberId == userProfile.memberAccount.uuid)
        //   return element.status;
        return element.memberId == vm.userProfile.memberAccount.uuid;
      });
      if (detail != null) {
        vm.dialogRadio = detail.status;
        item.scoreAll = detail.scoreAll;
        item.scoreProfession = detail.scoreProfession;
        item.scoreAttitude = detail.scoreAttitude;
        item.commentIp = detail.comment;
      }

      if (item.status == "C06") {
        vm.detailItem = item.interpreterCaseDetails.find(element => {
          // if (element.memberId == userProfile.memberAccount.uuid)
          //   return element.status;
          return (
            element.memberId == vm.userProfile.memberAccount.uuid &&
            element.status == "I05"
          );
        });
      }

      console.log("dialogRadio " + vm.dialogRadio);
    },
    getDetailScoreComment(item) {
      let detail = item.interpreterCaseDetails.find(element => {
        return element.status >= "I09";
      });
      if (detail != null) {
        item.scoreAll = detail.scoreAll;
        item.scoreProfession = detail.scoreProfession;
        item.scoreAttitude = detail.scoreAttitude;
        item.commentIp = detail.comment;
      }
    },
    getColor(value) {
      if (value == "C01") {
        return "#2196F3";
      } else if (value == "C02") {
        return "#311B92";
      } else if (value == "C03") {
        return "#009688";
      } else if (value == "C04") {
        return "#E91E63";
      } else if (value == "C05") {
        return "#EF6C00";
      } else if (value == "C06") {
        return "#EF6C00";
      } else if (value == "C07") {
        return "#00BCD4";
      } else if (value == "C08") {
        return "#00BCD4";
      } else if (value == "C09") {
        return "#9E9E9E";
      } else if (value == "I06") {
        return "#AA00FF";
      }
    },
    commentInterpreter() {
      var vm = this;
      vm.dialogResponeDept = !vm.dialogResponeDept;
      let detail = vm.targetItem.interpreterCaseDetails.find(element => {
        return element.status == "I09" || element.status == "I10";
      });

      detail.scoreAll = vm.scoreAll;
      detail.scoreProfession = vm.scoreProfession;
      detail.scoreAttitude = vm.scoreAttitude;
      detail.scoreAverage =
        Math.round(
          ((vm.scoreAll + vm.scoreProfession + vm.scoreAttitude) / 3) * 100
        ) / 100;
      detail.comment = vm.commentIp;
      detail.isCommentToInterpreter = "Y";

      vm.axios
        .put(vm.idbServerUrl + "idb/interpreterCaseDetail/C04", detail, {
          headers: {
            "Content-Type": "application/json",
            Authorization: vm.$localStorage.get("idb_login_token")
          }
        })
        .then(function() {
          // console.log("response " + JSON.stringify(response));

          vm.successSwalUtil();
          vm.dialogRating = false;
          console.log("Cancel!!!!!!! ");
          vm.getDataFromApi();
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          console.log("!!!! " + error);
        });

      console.log("SUCCESS!!!!!!! ");
    },
    checkObject() {
      var vm = this;
      if (vm.dialogRadio == "I05") {
        vm.submitCancelUtil().then(function(result) {
          if (result === true) {
            vm.dialogResponeIp = !vm.dialogResponeIp;
            // let userProfile = JSON.parse(vm.$localStorage.get("userProfileStr"));
            let detail = vm.targetItem.interpreterCaseDetails.find(element => {
              return element.memberId == vm.userProfile.memberAccount.uuid;
            });

            detail.status = vm.dialogRadio;
            let caseStatus = "";
            if (detail.status == "I05") {
              caseStatus = "C06";
              detail.cancelReason = vm.cancelReason;
              detail.cancelDate = new Date();
            }

            vm.axios
              .put(
                vm.idbServerUrl + "idb/interpreterCaseDetail/" + caseStatus,
                detail,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: vm.$localStorage.get("idb_login_token")
                  }
                }
              )
              .then(function() {
                // console.log("response " + JSON.stringify(response));
                vm.successSwalUtil();
                console.log("Cancel!!!!!!! ");
                vm.getDataFromApi();
              })
              .catch(function(error) {
                vm.handErrorUtil(error);
                console.log("!!!! " + error);
              });

            console.log("SUCCESS!!!!!!! ");
          } else if (result == "cancel") {
            console.log(" CANCEL!!!!!!!!!!!! ");
            vm.dialogResponeIp = false;
          }
        });
      } else if (vm.dialogRadio == "I08" || vm.dialogRadio == "I09") {
        let dateString = "開始服務時間";
        if (vm.dialogRadio == "I09") dateString = "結束服務時間";
        vm.submitDateTimeUtil(dateString).then(function(result) {
          if (result === true) {
            vm.dialogResponeIp = !vm.dialogResponeIp;
            // let userProfile = JSON.parse(vm.$localStorage.get("userProfileStr"));
            let detail = vm.targetItem.interpreterCaseDetails.find(element => {
              return element.memberId == vm.userProfile.memberAccount.uuid;
            });

            detail.status = vm.dialogRadio;
            let caseStatus = "";
            if (detail.status == "I08") {
              caseStatus = "C08";
              detail.startServiceDatetime = vm.confirmDateTime;
            } else if (detail.status == "I09") {
              caseStatus = "C04";
              detail.finishServiceDatetime = vm.confirmDateTime;
            }
            vm.axios
              .put(
                vm.idbServerUrl + "idb/interpreterCaseDetail/" + caseStatus,
                detail,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: vm.$localStorage.get("idb_login_token")
                  }
                }
              )
              .then(function(response) {
                console.log("response " + JSON.stringify(response));
                vm.successSwalUtil();
                console.log("SUCCESS!!!!!!! ");
                vm.getDataFromApi();
              })
              .catch(function(error) {
                vm.handErrorUtil(error);
                console.log("!!!! " + error);
              });

            console.log("SUCCESS!!!!!!! ");
          } else if (result == "cancel") {
            console.log(" CANCEL!!!!!!!!!!!! ");
            vm.dialogResponeIp = false;
          }
        });
      } else if (vm.dialogRadio == "I10") {
        vm.submitCommentUtil().then(function(result) {
          if (result === true) {
            vm.dialogResponeIp = !vm.dialogResponeIp;
            // let userProfile = JSON.parse(vm.$localStorage.get("userProfileStr"));
            let detail = vm.targetItem.interpreterCaseDetails.find(element => {
              return element.memberId == vm.userProfile.memberAccount.uuid;
            });

            detail.status = vm.dialogRadio;
            let caseStatus = "";
            if (detail.status == "I10") {
              caseStatus = "C04";
              detail.commentToDept = vm.comment;
            }

            vm.axios
              .put(
                vm.idbServerUrl + "idb/interpreterCaseDetail/" + caseStatus,
                detail,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: vm.$localStorage.get("idb_login_token")
                  }
                }
              )
              .then(function() {
                // console.log("response " + JSON.stringify(response));
                vm.successSwalUtil();
                console.log("Cancel!!!!!!! ");
                vm.getDataFromApi();
              })
              .catch(function(error) {
                vm.handErrorUtil(error);
                console.log("!!!! " + error);
              });

            console.log("SUCCESS!!!!!!! ");
          } else if (result == "cancel") {
            console.log(" CANCEL!!!!!!!!!!!! ");
            vm.dialogResponeIp = false;
          }
        });
      } else {
        vm.submitConfirmUtil().then(function(result) {
          if (result === true) {
            vm.dialogResponeIp = !vm.dialogResponeIp;
            // let userProfile = JSON.parse(vm.$localStorage.get("userProfileStr"));
            let detail = vm.targetItem.interpreterCaseDetails.find(element => {
              return element.memberId == vm.userProfile.memberAccount.uuid;
            });

            detail.status = vm.dialogRadio;
            let caseStatus = "";
            if (detail.status == "I01") caseStatus = "C01";
            else if (detail.status == "I02") caseStatus = "C01";
            else if (detail.status == "I04") caseStatus = "C03";
            else if (detail.status == "I07") {
              caseStatus = "C07";
              detail.checkInPosition = vm.targetAddress;
              detail.checkInDatetime = vm.checkInDatetime;
              detail.checkInLantitude = vm.targetPosition.lat;
              detail.checkInLongtitude = vm.targetPosition.lng;
            } else if (detail.status == "I08") {
              caseStatus = "C08";
              detail.startServiceDatetime = new Date();
            } else if (detail.status == "I09") {
              caseStatus = "C04";
              detail.finishServiceDatetime = new Date();
            }
            vm.axios
              .put(
                vm.idbServerUrl + "idb/interpreterCaseDetail/" + caseStatus,
                detail,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: vm.$localStorage.get("idb_login_token")
                  }
                }
              )
              .then(function(response) {
                console.log("response " + JSON.stringify(response));
                vm.successSwalUtil();
                console.log("SUCCESS!!!!!!! ");
                vm.getDataFromApi();
              })
              .catch(function(error) {
                vm.handErrorUtil(error);
                console.log("!!!! " + error);
              });

            console.log("SUCCESS!!!!!!! ");
          } else if (result == "cancel") {
            console.log(" CANCEL!!!!!!!!!!!! ");
            vm.dialogResponeIp = false;
          }
        });
      }
    },
    deptResponseObject(id) {
      var vm = this;
      console.log("id " + id);
      vm.updateTargetCaseId(id);
      vm.$router.push({
        path: "/caseResponseDept"
      });
    },
    copyCase(id) {
      var vm = this;
      vm.updateTargetCaseId(id);
      vm.$router.push({
        path: "/contactInterpreter"
      });
    }
  },
  mounted() {
    let vm = this;
    if (vm.userProfile.memberAccount.type == "CCC") {
      vm.caseStatusArray = vm.getCodeDateUtil("caseStatusForInterpreter");
    } else vm.caseStatusArray = vm.getCodeDateUtil("caseStatus");
    vm.getDataFromApi();
  },
  created() {
    let vm = this;
    Vue.SSE(
      vm.idbServerUrl +
        "idb/caseEvents?memberId=" +
        vm.userProfile.memberAccount.uuid,
      { format: "json" }
    )
      .then(sse => {
        msgServer = sse;
        sse.onError(e => {
          console.error("lost connection; giving up!", e);
          sse.close();
        });
        sse.subscribe("", itCase => {
          console.log("Received a message w/o an event!", itCase);
          let matchCase = vm.tableData.find(item => {
            return item.caseNo == itCase.caseNo;
          });
          if (matchCase != null) {
            if (matchCase.status != itCase.status) {
              matchCase.status = itCase.status;
            }

            console.log(itCase.status);
            console.log(itCase.caseNo);
          }
        });
      })
      .catch(err => {
        console.error("Failed to connect to server", err);
      });
  },
  beforeDestroy() {
    msgServer.close();
  }
};
</script>




